export default "__VITE_ASSET__CAy$WmZ1__"